import { Checkbox, Switch, Row, Col, Tooltip } from 'antd'
import { ContextMenu } from 'Components'
import { TYPE, GRAPH } from 'Types'
import Feather from '@sysunite/react-feather'

GraphFilterItem = ({
  color,
  enableByDefault,
  enabled,
  value,
  label,
  itemType,
  onChange,
  onClick
}) ->

  actions = (
    if itemType isnt GRAPH then [{
      key: 'toggle-disabled'
      title: "#{ enableByDefault && 'Hide' || 'Show' } item by default"
      onClick: -> onClick(!enableByDefault)
    }] else []
  )
  <ContextMenu actions={actions}>
    <div>
      <Checkbox checked={enabled} value={value} onChange={onChange}>
        {
          <span className={if !enableByDefault then 'disabledItem'}>
            { if itemType is TYPE then <Feather width="1em" height="1em" type="circle" style={{ fill: color, color }} />}
            { label }
          </span>
        }
      </Checkbox>
    </div>
  </ContextMenu>

export default GraphFilterItem
